(() => {
 const DAY=86400000;
 function timestamp(value){if(!/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}(?::\d{2})?(?:Z|[+-]\d{2}:\d{2})$/.test(value||''))return NaN;return Date.parse(value);}
 function remaining(mode,end,anchor,now){
  if(mode==='daily'){const start=timestamp(anchor);if(!Number.isFinite(start))return null;const target=start>now?start:start+(Math.floor((now-start)/DAY)+1)*DAY;return target-now;}
  const target=timestamp(end);return Number.isFinite(target)?Math.max(0,target-now):null;
 }
 function format(ms){let seconds=Math.ceil(ms/1000);const days=Math.floor(seconds/86400);seconds%=86400;const h=Math.floor(seconds/3600);const m=Math.floor(seconds%3600/60);const s=seconds%60;return (days?days+'d ':'')+[h,m,s].map(x=>String(x).padStart(2,'0')).join(' : ');}
 if(typeof module!=='undefined'&&module.exports)module.exports={remaining,format};
 if(typeof document==='undefined')return;
 if(!customElements.get('studio-countdown'))customElements.define('studio-countdown',class extends HTMLElement{
  connectedCallback(){
   clearInterval(this.timer);this.tick();this.timer=setInterval(()=>this.tick(),1000);
   if(this.classList.contains('izuro-announcement-countdown')){
    this.updateAnnouncementHeight=()=>document.documentElement.style.setProperty('--izuro-announcement-height',`${this.closest('.announcement-bar-section')?.getBoundingClientRect().height||0}px`);
    this.announcementObserver=new ResizeObserver(this.updateAnnouncementHeight);
    this.announcementObserver.observe(this.closest('.announcement-bar-section')||this);
    this.updateAnnouncementHeight();
   }
  }
  disconnectedCallback(){
   clearInterval(this.timer);this.announcementObserver?.disconnect();
   if(this.updateAnnouncementHeight)document.documentElement.style.removeProperty('--izuro-announcement-height');
  }
  tick(){const ms=remaining(this.dataset.mode,this.dataset.end,this.dataset.anchor,Date.now());if(ms===null){this.hidden=true;return;}const ended=ms===0;this.hidden=ended&&this.dataset.hideExpired==='true';this.querySelector('[data-timer-clock]').hidden=ended;this.querySelector('[data-timer-expired]').hidden=!ended;this.querySelector('.studio-sale-timer__heading').hidden=ended;this.querySelector('[data-timer-digits]').textContent=format(ms);if(ended)clearInterval(this.timer);}
 });
})();
